/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React from 'react';
import Props, {DispatchProps, StateProps} from './Props';
import {RootState} from '../../reducers';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {
	resetPasswordSceneAccountNameInputChanged,
	resetPasswordSceneAccountNameSubmitted,
	resetPasswordSceneActivated,
	resetPasswordSceneBackButtonClicked,
	resetPasswordSceneDeactivated
} from './actions';
import State from './State';
import {Button} from 'react-bootstrap';
import CenteredFormPanel from '../../components/CenteredFormPanel';
import FormGroup from '../../components/FormGroup';
import FormControl from '../../components/FormControl';
import {MessageType} from '../../model/messageType';

class ResetPassword extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);

		this.state = {accountName: ''};
	}

	componentDidMount() {
		const props: Readonly<Props> = this.props;

		props.onActivate();
	}

	componentWillUnmount() {
		const props: Readonly<Props> = this.props;

		props.onDeactivate();
	}

	handleAccountNameChange = (event: React.FormEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>): void => {
		const props: Readonly<Props> = this.props;

		this.setState(
			{accountName: String(event.currentTarget.value).trim()},
			() => props.onAccountNameChange()
		);
	};

	handleSubmit = () => {
		const props: Readonly<Props> = this.props;
		const state: Readonly<State> = this.state;

		if (!props.submitDisabled)
			props.onSubmit(state.accountName);
	};

	render() {
		const props: Readonly<Props> = this.props;
		const state: Readonly<State> = this.state;

		return (
			<CenteredFormPanel message={props.message} messageType={MessageType.INFO} title="Wachtwoord opnieuw instellen">
				<FormGroup controlId="email" label="E-mail:" violations={props.violations.accountName}>
					<FormControl
						autoComplete="username email"
						autoFocus={true}
						type="email"
						placeholder="E-mail"
						value={state.accountName}
						isInvalid={(props.violations.accountName || []).length > 0}
						disabled={props.submitDisabled}
						onChange={this.handleAccountNameChange}
						onEnter={this.handleSubmit}/>
				</FormGroup>
				<Button
					type="button"
					className="float-end"
					variant="primary"
					onClick={this.handleSubmit}
					disabled={props.submitDisabled}>
					{'Versturen'}
				</Button>
				<Button type="button" className="float-start" variant="link" onClick={props.onBackButtonClick}>
					{'Terug naar inloggen'}
				</Button>
			</CenteredFormPanel>
		);
	}
}

const mapStateToProps = (state: RootState): StateProps => ({
	message: state.resetPassword.message,
	submitDisabled: state.resetPassword.submitDisabled,
	violations: state.resetPassword.violations
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
	onAccountNameChange: () => dispatch(resetPasswordSceneAccountNameInputChanged()),
	onActivate: () => dispatch(resetPasswordSceneActivated()),
	onBackButtonClick: () => dispatch(resetPasswordSceneBackButtonClicked()),
	onDeactivate: () => dispatch(resetPasswordSceneDeactivated()),
	onSubmit: (accountName: string) => dispatch(resetPasswordSceneAccountNameSubmitted({command: {accountName}}))
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
